import { Link } from 'react-router-dom'

function NotFoundPage() {
  return (
    <div style={{ textAlign: 'center', padding: '4rem 2rem' }}>
      <h1>404 - Page Not Found</h1>
      <p>The page you're looking for doesn't exist.</p>
      <Link to='/' style={{ color: '#0066cc', textDecoration: 'underline' }}>
        Go back home
      </Link>
    </div>
  )
}

export default NotFoundPage
